<template>
  <div>
    <!-- User list -->
    <div>
      <vs-table
          id="user-list"
          class="vs-con-loading__container"
          stripe
          :sst="true"
          maxHeight="800px"
          @search="updateSearchQuery"
          @change-page="handleChangePage"
          @sort="handleSort"
          :total="FilteredCount"
          :max-items="length"
          search
          :data="records"
      >
        <template slot="header">
         
            <div class="user-table-header-actions">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>

              <div class="flex flex-wrap items-center">
                <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
              </div>

              <div v-if="search" class="user-search-results">
                {{ records.length || 0 }} results found.
              </div>
               <div class="user-table-header">
           

            </div>
             <div class="user-filter-tabs">
              <button
                v-for="tab in filterTabs"
                :key="tab.key"
                type="button"
                class="user-filter-tab"
                :class="{ 'user-filter-tab--active': activeFilterTab === tab.key }"
                @click="setActiveFilter(tab.key)"
              >
                {{ tab.label }}
                (<span v-if="isCountsLoading || (isTabLoading && activeFilterTab === tab.key)" class="count-skeleton"></span>
                <span v-else>{{ getTabCount(tab.key) }}</span>)
              </button>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th sort-key="User.image">Image</vs-th>
          <vs-th sort-key="User.first_name">First Name</vs-th>
          <vs-th sort-key="User.last_name">Last Name</vs-th>
          <vs-th sort-key="User.email">Email</vs-th>
          <vs-th sort-key="User.handle_name">Handle Name</vs-th>
          <vs-th sort-key="User.handle_name">Referral By</vs-th>
          <vs-th sort-key="User.handle_name">Referral Count</vs-th>
          <vs-th sort-key="User.mobile_number">Mobile Number</vs-th>
          <vs-th sort-key="User.country">Country</vs-th>
          <vs-th sort-key="User.state">State</vs-th>
          <vs-th sort-key="User.city">City</vs-th>
          <vs-th sort-key="User.gender">Gender</vs-th>
          <vs-th sort-key="User.device_type">Device Type</vs-th>
          <vs-th sort-key="User.artist">Artist</vs-th>
          <vs-th sort-key="User.createdAt">Registration Date</vs-th>
          <vs-th sort-key="User.role.role">Role</vs-th>
          <vs-th v-if="activeFilterTab === 'gurudwara-admin'">Gurudwara</vs-th>
          <vs-th v-if="activeFilterTab === 'organization-admin'">Organization</vs-th>
          <vs-th v-if="activeFilterTab === 'hotel-manager'">Hotel</vs-th>
          <vs-th sort-key="User.is_premium" v-if="featureFlags.enableSubscriptions">Type</vs-th>
          <vs-th v-if="showUserActionColumn">Action</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td> <img :src="tr.image" class="rounded object-cover" height="50px" width="50px" :alt="`${tr.first_name} ${tr.last_name}`" /> </vs-td>
            <vs-td>
              <span
                v-if="featureFlags.enableSubscriptions && checkPermissionSlug(['user_subscription_list'])"
                class="cursor-pointer"
                @click.stop="toggleShowModal(tr._id, $event)"
                v-tooltip="{ content: `View ${tr.first_name} Subscriptions ` }"
                >{{ (tr && tr.first_name) || '-' }}</span
              >
              <span v-else>{{ (tr && tr.first_name) || '-' }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.last_name }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.email || '-' }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.handle_name }}</span>
            </vs-td>
            <vs-td>
              <span>{{ (tr.referrer && (tr.referrer.first_name + ' ' + tr.referrer.last_name)) || '-' }}</span>
            </vs-td>
            <vs-td>
              <span :class="{ 'cursor-pointer': tr.referral_count > 0 }" @click.stop="tr.referral_count > 0 ? rfferedUserlistModal(tr) : null">
                {{ tr.referral_count || 0 }}
              </span>
            </vs-td>
            <vs-td>
              <span>{{ tr.mobile_number }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.country && tr.country.country_name ? tr.country.country_name : '-' }} </span>
            </vs-td>
            <vs-td>
              <span>{{ tr.state && tr.state.name ? tr.state.name : '-' }} </span>
            </vs-td>
            <vs-td>
              <span>{{ tr.city && tr.city.name ? tr.city.name : '-' }} </span>
            </vs-td>
            <vs-td>
              <span>{{ tr.gender || '-' }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.device_detail ? tr.device_detail.device_type : '-' }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.creator && tr.creator.name ? tr.creator.name : '-' }}</span>
            </vs-td>
            <vs-td>
              <span>{{ moment(tr.createdAt).local().format('Do MMMM YYYY, h:mm:ss A') }}</span>
            </vs-td>
            <vs-td>
              <vs-chip :color="tr.role && tr.role.slug === 'admin' ? 'danger' : 'primary'">{{ tr.role && tr.role.role ? tr.role.role : '-' }} </vs-chip>
            </vs-td>
            <vs-td v-if="activeFilterTab === 'gurudwara-admin'">
              <span>{{ (tr.managed_gurudwara_names && tr.managed_gurudwara_names.length && tr.managed_gurudwara_names.join(', ')) || '-' }}</span>
            </vs-td>
            <vs-td v-if="activeFilterTab === 'organization-admin'">
              <span>{{ (tr.managed_organization_names && tr.managed_organization_names.length && tr.managed_organization_names.join(', ')) || '-' }}</span>
            </vs-td>
            <vs-td v-if="activeFilterTab === 'hotel-manager'">
              <span>{{ (tr.managed_hotel_names && tr.managed_hotel_names.length && tr.managed_hotel_names.join(', ')) || '-' }}</span>
            </vs-td>
            <vs-td v-if="featureFlags.enableSubscriptions">
              <vs-chip :color="tr.is_premium ? 'success' : 'warning'">{{ tr.is_premium ? 'Premium' : 'Free' }} </vs-chip>
            </vs-td>
            <vs-td v-if="showUserActionColumn">
              <div class="inline-flex justify-center">
                <vx-tooltip :text="`View ${tr.first_name} Subscriptions`" v-if="showUserSubscriptionActions">
                  <feather-icon @click.stop="toggleShowModal(tr._id, $event)" icon="EyeIcon" svgClasses="h-5 w-5 mr-2 cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip :text="`Assign Artist`" v-if="checkPermissionSlug(['user_assign_artist'])">
                  <feather-icon @click.stop="assignArtistModal(tr)" icon="PlusSquareIcon" svgClasses="h-5 w-5 mr-2 cursor-pointer" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <vs-popup class="holamundo" title="Refferd Users List" :active.sync="isReffedUserModalShow" fullscreen>
      <div>
        <vs-table id="referred-user-list" class="vs-con-loading__container" stripe :sst="true" maxHeight="500px" :data="refferdUsers">
          <template slot="thead">
            <vs-th>Sr#</vs-th>
            <vs-th sort-key="User.first_name">First Name</vs-th>
            <vs-th sort-key="User.last_name">Last Name</vs-th>
            <vs-th sort-key="User.email">Email</vs-th>
            <vs-th sort-key="User.email">Mobile No</vs-th>
            <vs-th sort-key="User.email">Handle Name</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
              <vs-td>
                {{ page * length - (length - i - 1) }}
              </vs-td>
              <vs-td>
                <span>{{ tr.first_name }}</span>
              </vs-td>
              <vs-td>
                <span>{{ tr.last_name }}</span>
              </vs-td>
              <vs-td>
                <span>{{ tr.email || "-" }}</span>
              </vs-td>
              <vs-td>
                <span>{{ tr.mobile_number }}</span>
              </vs-td>
              <vs-td>
                <span>{{ tr.handle_name }}</span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-popup>
    <!-- Assign artist modal -->
    <assign-artist-modal
      :module_name="module_name"
      @update-data="getData"
      v-if="isAssignArtistModalMounted"
      :showModal.sync="isAssignArtistModalShow"
      :data="selectedRecord"
      :action_name="'Assign Artist'"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import assignArtistModal from '@/views/user/assign-artist'
import moment from 'moment'
import featureFlags from '@/config/featureFlags'

export default {
  name: 'UserList',

  components: {
    assignArtistModal
  },

  /** Data */
  data: () => ({
    featureFlags,
    order: [],
    length: 10,
    page: 1,
    search: '',
    activeFilterTab: 'user',
    filterTabs: [
      // { key: 'all', label: 'All Users' },
      { key: 'user', label: 'Users' },
      { key: 'artist', label: 'Artists' },
      { key: 'hotel-manager', label: 'Hotel Managers' },
      { key: 'gurudwara-admin', label: 'Gurudwara Admins' },
      { key: 'organization-admin', label: 'Organization Admins' }
    ],
    module_name: 'User',

    // assign artist modal
    isAssignArtistModalMounted: false,
    isAssignArtistModalShow: false,
    isReffedUserModalMounted: false,
    isReffedUserModalShow: false,
    selectedRecord: null,
    rfferdUserId: null,
    tabCounts: {},
    isCountsLoading: false,
    isTabLoading: false
  }),

  /** computed */
  computed: {
    ...mapState('user', ['records', 'total', 'FilteredCount', 'listLoading', 'refferdUsers', 'refferdUsersLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    },
    showUserSubscriptionActions() {
      return this.featureFlags.enableSubscriptions && this.checkPermissionSlug(['user_subscription_list'])
    },
    showUserActionColumn() {
      return this.checkPermissionSlug(['user_assign_artist']) || this.showUserSubscriptionActions
    }
  },

  /** Functions */
  methods: {
    moment,
    ...mapActions('user', {
      get: 'get',
      delete: 'delete',
      getRefferdUsers: 'getRefferdUsers',
      getTabCountsAction: 'getTabCounts'
    }),

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    setActiveFilter(tabKey) {
      if (this.activeFilterTab === tabKey) return
      this.activeFilterTab = tabKey
      this.page = 1
      this.getData()
    },
    getTabCount(tabKey) {
      const count = this.tabCounts[tabKey]
      return count !== undefined ? count : '-'
    },
    async fetchTabCounts() {
      this.isCountsLoading = true
      try {
        const response = await this.getTabCountsAction()
        if (response && response.success) {
          this.tabCounts = response.data
        }
      } catch (error) {
        console.error('Error fetching tab counts:', error)
      } finally {
        this.isCountsLoading = false
      }
    },

    /** Mantra List API */
    async getData() {
      this.isTabLoading = true
      const params = {
        limit: this.length,
        page: this.page,
        search: this.search
      }

      if (this.activeFilterTab !== 'all') {
        params.role_slug = this.activeFilterTab
      }

      try {
        await this.get({
          ...params
        })
        // Update the specific tab count after fetching data, only if not searching
        if (!this.search) {
          this.$set(this.tabCounts, this.activeFilterTab, this.FilteredCount)
        }
      } catch (error) {
        console.error('Error fetching user data:', error)
      } finally {
        this.isTabLoading = false
      }
    },
    getRfferdData() {
      this.getRefferdUsers({
        userId: this.rfferdUserId
      })
    },

    // subscriptionn show modal
    toggleShowModal(id, event) {
      const viewUrl = `/user/${id}/subscription-list`
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(viewUrl, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(viewUrl)
      }
    },

    // assign artist modal
    assignArtistModal(data) {
      this.isAssignArtistModalMounted = true
      this.isAssignArtistModalShow = true
      this.selectedRecord = data
    },
    rfferedUserlistModal(data) {
      this.isReffedUserModalShow = true
      this.rfferdUserId = data._id
      this.getRfferdData()
    }
  },

  /** Watchers */
  watch: {
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#user-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#user-list > .con-vs-loading')
      }
    },
    refferdUsersLoading() {
      if (this.refferdUsersLoading) {
        this.$vs.loading({
          container: '#referred-user-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#referred-user-list > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    },
    isAssignArtistModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAssignArtistModalMounted = false
          }, 0)
        }
      }
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
    this.fetchTabCounts()
  }
}
</script>

<style scoped>
.user-table-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.user-filter-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.user-filter-tab {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 9999px;
  padding: 10px 18px;
  text-align: center;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.theme-dark .user-filter-tab {
  border-color: rgba(255, 255, 255, 0.2);
}

.user-filter-tab--active {
  background: rgba(var(--vs-primary), 1) !important;
  color: #fff !important;
  border-color: rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 6px 16px rgba(var(--vs-primary), 0.25);
}

.user-table-header-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.user-search-results {
  font-weight: 500;
}

.count-skeleton {
  display: inline-block;
  width: 20px;
  height: 14px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  vertical-align: middle;
  animation: skeleton-pulse 1.5s infinite ease-in-out;
}

.theme-dark .count-skeleton {
  background: rgba(255, 255, 255, 0.1);
}

@keyframes skeleton-pulse {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}

@media (max-width: 768px) {
  .user-table-header-actions {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
